import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRouter from 'constants/apiRouting'
import { SHOW_NOTICE } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import {
  FETCH_SITE_LIST,
  SUCCESS_SITE_LIST,
  FAILURE_SITE_LIST,
  SET_SITE_LIST_LOADER,
  FETCH_FORM_LIST,
  SUCCESS_FORM_LIST,
  FAILURE_FORM_LIST,
  SET_FORM_LIST_LOADER,
  SET_FORM_EVENT_VALUE_LOADER,
  FETCH_LOCUS_GROUP_LIST,
  SUCCESS_LOCUS_GROUP_LIST,
  FAILURE_LOCUS_GROUP_LIST,
  SET_LOCUS_GROUP_LIST_LOADER,
  SET_LOCUS_GROUP_EVENT_VALUE_LOADER,
  FETCH_LOCUS_LIST,
  SUCCESS_LOCUS_LIST,
  FAILURE_LOCUS_LIST,
  SET_LOCUS_LIST_LOADER,
  SET_LOCUS_EVENT_VALUE_LOADER,
  FETCH_FORM_EVENT_LIST_WITH_DATA,
  SUCCESS_FORM_EVENT_LIST_WITH_DATA,
  FAILURE_FORM_EVENT_LIST_WITH_DATA,
  SET_FORM_EVENT_LIST_WITH_DATA_LOADER,
  FETCH_FORM_LEVEL_EVENT_VALUES,
  SUCCESS_FORM_LEVEL_EVENT_VALUES,
  FAILURE_FORM_LEVEL_EVENT_VALUES,
  FETCH_LOCUS_GROUP_LEVEL_EVENT_VALUES,
  SUCCESS_LOCUS_GROUP_LEVEL_EVENT_VALUES,
  FAILURE_LOCUS_GROUP_LEVEL_EVENT_VALUES,
  FETCH_LOCUS_LEVEL_EVENT_VALUES,
  SUCCESS_LOCUS_LEVEL_EVENT_VALUES,
  FAILURE_LOCUS_LEVEL_EVENT_VALUES,
  SAVE_EVENT_FORM,
} from './reducer'

function* fetchSiteList({ payload, promise }) {
  try {
    yield put({ type: SET_SITE_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.SITE_LIST}${UrlHelper.getPsfsQuery(payload)}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_SITE_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_SITE_LIST })
    }

    yield put({ type: SET_SITE_LIST_LOADER, payload: false })

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchFormList(action) {
  try {
    yield put({ type: SET_FORM_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.LOGBOOK_FORM_LIST, action.payload),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_FORM_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_FORM_LIST })
    }

    yield put({ type: SET_FORM_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('LOGBOOK FORM FAILED ', error)
  }
}

function* fetchFormEventListWithData({ payload }) {
  try {
    yield put({ type: SET_FORM_EVENT_LIST_WITH_DATA_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        UrlHelper.create(ApiRouter.LOGBOOK_FORM_EVENT_LIST_WITH_DATA, payload),
        payload.params,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_FORM_EVENT_LIST_WITH_DATA,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_FORM_EVENT_LIST_WITH_DATA })
    }

    yield put({ type: SET_FORM_EVENT_LIST_WITH_DATA_LOADER, payload: false })
  } catch (error) {
    console.log('LOGBOOK FORM FAILED ', error)
  }
}

function* fetchLocusGroupList(action) {
  try {
    yield put({ type: SET_LOCUS_GROUP_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_GROUPS}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_LIST })
    }

    yield put({ type: SET_LOCUS_GROUP_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchLocusList(action) {
  try {
    yield put({ type: SET_LOCUS_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      if (!response.length) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createWarningObj('Unit list is empty'),
        })
      }

      yield put({
        type: SUCCESS_LOCUS_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_LIST })
    }

    yield put({ type: SET_LOCUS_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchFormLevelEventValues(action) {
  try {
    yield put({ type: SET_FORM_EVENT_VALUE_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.LOGBOOK_FORM_EVENT_VALUES,
        action.payload.params,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_FORM_LEVEL_EVENT_VALUES,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_FORM_LEVEL_EVENT_VALUES })
    }

    yield put({ type: SET_FORM_EVENT_VALUE_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchLocusGroupLevelEventValues(action) {
  try {
    yield put({ type: SET_LOCUS_GROUP_EVENT_VALUE_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.LOGBOOK_LOCUS_GROUP_EVENT_VALUES,
        action.payload.params,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_LEVEL_EVENT_VALUES,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_LEVEL_EVENT_VALUES })
    }

    yield put({ type: SET_LOCUS_GROUP_EVENT_VALUE_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchLocusLevelEventValues(action) {
  try {
    yield put({ type: SET_LOCUS_EVENT_VALUE_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.LOGBOOK_LOCUS_EVENT_VALUES,
        action.payload.params,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_LEVEL_EVENT_VALUES,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_LEVEL_EVENT_VALUES })
    }

    yield put({ type: SET_LOCUS_EVENT_VALUE_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* saveEventForm({ payload, promise }) {
  try {
    const { event, form, params } = payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        event
          ? ApiRouter.LOGBOOK_SINGLE_EVENT_FILLED
          : ApiRouter.LOGBOOK_ENTRY_SAVE,
        event || params,
      ),
      method: event ? 'PUT' : 'POST',
      data: form,
    })

    if (response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('Event change crashed!'),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('LOGBOOK FORM SAVE FAILED ', error)
  }
}

function* logbookFormSaga() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_FORM_LIST, fetchFormList)
  yield takeLatest(FETCH_FORM_EVENT_LIST_WITH_DATA, fetchFormEventListWithData)
  yield takeLatest(FETCH_LOCUS_GROUP_LIST, fetchLocusGroupList)
  yield takeLatest(FETCH_LOCUS_LIST, fetchLocusList)
  yield takeLatest(FETCH_FORM_LEVEL_EVENT_VALUES, fetchFormLevelEventValues)
  yield takeLatest(
    FETCH_LOCUS_GROUP_LEVEL_EVENT_VALUES,
    fetchLocusGroupLevelEventValues,
  )
  yield takeLatest(FETCH_LOCUS_LEVEL_EVENT_VALUES, fetchLocusLevelEventValues)
  yield takeLatest(SAVE_EVENT_FORM, saveEventForm)
}

export default logbookFormSaga
